import './ellipsis.css';
export var ellipsis = '_oqqp1n0-3-8-0';